export default "__VITE_ASSET__DwNhWLm6__"